import request from '@/utils/request'

export function getList(params = {}) {
  return request({
    url: '/report_form/predit/channel_form',
    method: 'get',
    params
  })
}

export function exportChannelGeneralReport(data = {}) {
  return request({
    url: '/report_form/export/channel_form',
    method: 'post',
    data
  })
}
